import PropTypes from 'prop-types';
import { Box, Skeleton, Typography } from '@mui/material';
import QuadPanel from 'features/IRWorkstation/components/Common/QuadPanel';

const VISIBLE_LINES = 5;
const LINE_HEIGHT = 1.45;
const FONT_SIZE = 13;
const PADDING_Y = 18;
const TEXT_HEIGHT = `${VISIBLE_LINES * LINE_HEIGHT * FONT_SIZE}px`;
const BOX_HEIGHT = `${VISIBLE_LINES * LINE_HEIGHT * FONT_SIZE + PADDING_Y}px`;

const LPDescriptionCard = ({ description = '', loading = false }) => (
	<Box
		data-testid='lp-description-card'
		sx={{ width: '100%', minWidth: 0, display: 'flex', '& > *': { flex: 1 } }}
	>
		<QuadPanel title='Description'>
			<Box
				sx={{
					height: BOX_HEIGHT,
					maxHeight: BOX_HEIGHT,
					overflowY: 'auto',
					padding: '9px 14px',
				}}
			>
				{loading ? (
					<Box
						sx={{
							height: TEXT_HEIGHT,
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						{Array.from({ length: VISIBLE_LINES }).map((_, i) => (
							<Skeleton
								key={i}
								variant='text'
								height={FONT_SIZE * LINE_HEIGHT}
								width='100%'
								sx={{ display: 'block' }}
							/>
						))}
					</Box>
				) : (
					<Typography
						variant='body1'
						sx={{
							fontSize: `${FONT_SIZE}px`,
							lineHeight: LINE_HEIGHT,
							color: description ? 'text.primary' : 'text.secondary',
							whiteSpace: 'pre-wrap',
							overflowWrap: 'break-word',
						}}
					>
						{description || 'No description'}
					</Typography>
				)}
			</Box>
		</QuadPanel>
	</Box>
);

LPDescriptionCard.propTypes = {
	description: PropTypes.string,
	loading: PropTypes.bool,
};

export default LPDescriptionCard;
